import React, { useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import DynamicTopMainAndSubNavbar from "./DynamicTopMainAndSubNavbar";
import KraLandingView from "../methods/KraLanding";
import { Button } from "@mui/material";
import UserSpecificLanding from "./userSpecific/UserSpecificLanding";
import MethodsLanding from "../methods/MethodsLanding";
import AdminGoals from "../../L&D/Appraisal/adminOperations/goals/AdminGoals";
import Skills from "../../L&D/Appraisal/adminOperations/Skills/Skills";
import KraAllView from "./userSpecific/Kra/KraAllView";
import SkillAllView from "../methods/skill/SkillAllView";
import WillAllView from "../methods/will/WillAllView";
import AppraisalCycle from "../../L&D/Appraisal/adminOperations/appraisalCycle/appraisalCycle";

const AppraisalAdminOperations = () => {
  const topBarDatas = [
    {
      id: 1,
      buttonName: "Perfomance",
      component: null,
      icon: <Icon icon="icon-park-outline:application-effect" />,
      childrens: [
        {
          id: 1,
          buttonName: "User - specific Operations",
          component: <UserSpecificLanding />,
          icon: <Icon icon="tdesign:user-filled" height={15} />,
        },
        {
          id: 2,
          buttonName: "Methods",
          component: <MethodsLanding />,
          icon: (
            <Icon
              icon="ep:switch"
              width=""
              height="15"
              style="color: #7e408b"
            />
          ),
        },
        {
          id: 3,
          buttonName: "KRA",
          component: <KraAllView />,
          icon: <Icon icon="uiw:area-chart" height={15} />,
        },
        {
          id: 4,
          buttonName: "Skill",
          component: <SkillAllView />,
          icon: <Icon icon="carbon:skill-level-advanced" height={15} />,
        },
        {
          id: 5,
          buttonName: "Will",
          component: <WillAllView />,
          icon: (
            <Icon
              icon="icon-park-solid:lightning"
              height={15}
              style="color: #7e408b"
            />
          ),
        },
        {
          id: 6,
          buttonName: "Appraisal",
          component: <AppraisalCycle />,
          icon: (
            <Icon
              icon="icon-park-solid:lightning"
              height={15}
              style="color: #7e408b"
            />
          ),
        },
        // {
        //   id: 6,
        //   buttonName: "Goals",
        //   component: (
        //     <div>
        //       <AdminGoals />
        //     </div>
        //   ),
        //   icon: (
        //     <Icon
        //       icon="arcticons:ironwill"
        //       height={15}
        //       style="color: #7e408b"
        //     />
        //   ),
        // },
      ],
    },
    // {
    //   id: 2,
    //   buttonName: "Tab 2",
    //   component: null,
    //   icon: <Icon icon="codicon:symbol-method" />,
    //   childrens: [],
    // },
  ];

  const [selectedTopId, setSelectedTopId] = useState(
    topBarDatas[0]?.id || null
  );
  const [selectedChildId, setSelectedChildId] = useState(null); //BY DEFAULT THE CHILD IS NULL

  return (
    <>
      <DynamicTopMainAndSubNavbar
        topBarDatas={topBarDatas}
        selectedTopId={selectedTopId}
        setSelectedTopId={setSelectedTopId}
        selectedChildId={selectedChildId}
        setSelectedChildId={setSelectedChildId}
        isShowHidButtonRequired={true}
      />
    </>
  );
};

export default AppraisalAdminOperations;
